var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"btn btn-outline-primary rounded-circle border-2",attrs:{"type":"button"},on:{"click":function($event){return _vm.$emit('click')}}},[_c('i',{class:_vm.iconClass})])
}
var staticRenderFns = []

export { render, staticRenderFns }